export default "__VITE_ASSET__b4adffcb__"